import { IRootState } from '../../../store'

export const getToastSelector = (state: IRootState) => state.toast
